import styled from 'styled-components';

export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    animation: fadeIn 0.2s ease-in;

    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }
`;

export const ModalContent = styled.div`
    background: linear-gradient(135deg, #2a2a2a 0%, #1f1f1f 100%);
    border-radius: 16px;
    padding: 35px 30px;
    width: 90%;
    max-width: 450px;
    text-align: center;
    position: relative;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
    animation: slideUp 0.3s ease-out;

    @keyframes slideUp {
        from {
            transform: translateY(20px);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }
`;

export const CloseButton = styled.button`
    position: absolute;
    top: 15px;
    right: 15px;
    background: transparent;
    border: none;
    color: #999;
    font-size: 28px;
    cursor: pointer;
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    border-radius: 50%;

    &:hover {
        background: rgba(255, 255, 255, 0.1);
        color: white;
    }
`;

export const IconWrapper = styled.div`
    font-size: 60px;
    margin-bottom: 15px;
    animation: bounce 0.6s ease-in-out;

    @keyframes bounce {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.1); }
    }
`;

export const ModalTitle = styled.h2`
    color: white;
    font-size: 26px;
    margin-bottom: 20px;
    font-weight: bold;
`;

export const ModalText = styled.p`
    color: #ccc;
    font-size: 16px;
    line-height: 1.6;
    margin-bottom: 15px;

    strong {
        color: rgb(247, 144, 0);
    }
`;

export const ModalHighlight = styled.span`
    color: rgb(247, 144, 0);
    font-weight: bold;
`;

export const ModalButtons = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 25px;
`;

export const PrimaryButton = styled.button`
    background: linear-gradient(135deg, rgb(247, 144, 0) 0%, rgb(220, 120, 0) 100%);
    color: white;
    border: none;
    border-radius: 8px;
    padding: 14px 24px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s;
    box-shadow: 0 4px 15px rgba(247, 144, 0, 0.3);

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(247, 144, 0, 0.4);
    }

    &:active {
        transform: translateY(0);
    }
`;

export const SecondaryButton = styled.button`
    background: transparent;
    color: white;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
        border-color: rgba(255, 255, 255, 0.6);
        background: rgba(255, 255, 255, 0.05);
    }
`;
